import { useSelector } from '@/libs/state'
import { formatDate } from '../application/format-date'
import { userPreferences$ } from '../store'
import type { DateValue } from '../domain/date-format'

const useDateFormat = () => {
	const preferences = useSelector(() => userPreferences$.get())

	const formatPreferenceDate = (value: DateValue) =>
		formatDate(preferences.locale, value, { kind: 'date', dateFormat: preferences.dateFormat })
	const formatPreferenceDateTime = (value: DateValue) =>
		formatDate(preferences.locale, value, {
			kind: 'dateTime',
			dateFormat: preferences.dateFormat,
			timeFormat: preferences.timeFormat,
		})

	return { formatPreferenceDate, formatPreferenceDateTime }
}

export { useDateFormat }
